import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import bunoLogo from '@/assets/logo_buno_plus.svg';

export default function Landing() {
  const navigate = useNavigate();

  
  return (
    <>
      <div className="container px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            ¡Felicidades! Estás por mejorar tu salud y energía
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8">
            Acompañamiento experto para iniciar y mantener tu terapia CPAP 100% remoto.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              className="min-h-touch text-lg px-6 sm:px-8 gap-0 w-full"
              onClick={() => navigate('/introduccion')}
            >
              <span className="">Empezar ahora</span>
              <ChevronRight style={{ marginLeft: '2.5px', width: '1.25rem', height: '1.25rem', strokeWidth: '3px'}}/>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}